import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Support THread</Typography>
      <p>The conversation view clearly shows your messages and our responses.</p>

      <p>You can add additional messages with the form.</p>
    
      <Typography variant='h5' className='pt-10 pb-5'>Closing a thread</Typography>
      <p>You can close a support thread when you are happy in two ways. Either click 
        the [CLOSE THREAD] button to close immediately, or send us a final message 
        and toggle the close thread button to <i>yes</i></p>
    </div>
  )
}

export default HelpText